import { faCircleInfo } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material';
import MUITypography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export default function RequirementsBoxText({ newPassword }: { newPassword?: boolean }) {
  const { t } = useTranslation('authentication');
  return (
    <>
      <RequirementsTitle>
        <TitleIcon icon={faCircleInfo} />
        <MUITypography>
          {t('password.requirements.yourPasswordMustContain', { context: newPassword ? 'new' : '' })}
        </MUITypography>
      </RequirementsTitle>
      <RequirementsText>
        <MUITypography>• {t('password.requirements.minimumCharacters', { minimum: 8 })}</MUITypography>
        <MUITypography>• {t('password.requirements.atLeastOneUppercaseLetter')}</MUITypography>
        <MUITypography>• {t('password.requirements.atLeastOneLowercaseLetter')}</MUITypography>
        <MUITypography>• {t('password.requirements.atLeastOneNumber')}</MUITypography>
      </RequirementsText>
    </>
  );
}

const RequirementsTitle = styled('div')`
  text-align: left;
  margin-left: 1rem;
  display: flex;
`;

const TitleIcon = styled(FontAwesomeIcon)`
  font-size: 1.5rem;
  margin-right: 0.5rem;
`;

const RequirementsText = styled('div')`
  text-align: left;
  margin-left: 3.125rem;
`;

export const PasswordGroup = styled('div')`
  position: relative;
`;
